import { render, staticRenderFns } from "./Cinema.vue?vue&type=template&id=e1e3963e&"
import script from "./Cinema.vue?vue&type=script&lang=ts&"
export * from "./Cinema.vue?vue&type=script&lang=ts&"
import style0 from "./Cinema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports